var evelixShopifyPre,Azx_money_format = '${{amount}}',sp_azx_storage = false,Enablestorage = true;
try {
   sp_azx_storage = (typeof(Storage) !== "undefined" && Enablestorage);
} catch (err) {
   sp_azx_storage = false;
}
if(sp_azx_storage) {
var azx_currency = localStorage.getItem('azx_currency');
} else {
 var azx_currency = null;
}
(function( $ ) {
   "use strict";
   evelixShopifyPre = (function() {
   return {
      init: function() {
         this.initCarousel();
         this.initMasonry(); 
         this.shopMasonry();
      },    

      // Init slick carousel
      initCarousel : function() {
         $( '.azx-carousel' ).not( '.slick-initialized' ).slick();
      },
      StorageCurrency: function () {
        var cookieCurrency = null;
        if(sp_azx_storage) {cookieCurrency = localStorage.getItem('T4Currency')}
        return cookieCurrency;
      },
       // Categories masonry
      shopMasonry: function() {
         if (typeof($.fn.isotope) == 'undefined' || typeof($.fn.imagesLoaded) == 'undefined') return;
          // Categories masonry
          $(window).resize(function() {
            $(".categories-masonry").each(function (index) {
              var $el = $(this);
              var colWidth = ( $el.hasClass( 'categories-style-masonry' ) )  ? '.azx-item-category' : '.col-lg-3.azx-item-category' ;
              $el.imagesLoaded().done( function(instance) {
                  setTimeout(function(){
                     $el.isotope({
                         resizable: false,
                         isOriginLeft: ! $('body').hasClass('rtl'),
                         layoutMode: 'packery',
                         packery: {
                             gutter: 0,
                             columnWidth: colWidth
                         },
                         itemSelector: '.azx-item-category',
                         // masonry: {
                             // gutter: 0
                         // }
                     });
                     
                  }, 500);
                  // setTimeout(function(){
                  //    $el.isotope('layout');
                  // }, 2500);
              });
            });
          });
      },

      // Init masonry layout
      initMasonry : function() {
         if (typeof($.fn.isotope) == 'undefined' || typeof($.fn.imagesLoaded) == 'undefined') return;
         var el = $( '.azx-masonry' );
       
         el.each( function( i, val ) {
            var _option = $( this ).data( 'masonry' );
              //console.log(_option)
            if ( _option !== undefined ) {
               var _selector = _option.selector,
                  _width    = _option.columnWidth,
                  _layout   = _option.layoutMode;

               $( this ).imagesLoaded( function() {
                  $( val ).isotope( {
                     layoutMode : _layout,
                     isOriginLeft: ! $('body').hasClass('rtl'),
                     itemSelector: _selector,
                     percentPosition: true,
                     masonry: {
                        columnWidth: _width
                     }
                  } );
               });

               $( '.azx_filter_iso a' ).click( function() {
                  var selector = $( this ).data( 'filter' ),
                     parent   = $( this ).parents( '.azx_filter_iso' );

                  $( val ).isotope({ filter: selector });

                  // don't proceed if already selected
                  if ( $( this ).hasClass( 'selected' ) ) {
                     return false;
                  }
                  parent.find( '.selected' ).removeClass( 'selected' );
                  $( this ).addClass( 'selected' );

                  return false;
               });
            }
         });
      },
      Azxproduct_switch: function(variations_form,Azxproduct,product,selector,IdSelect,AzxId,callBackVariant,prefix) {
         var $variation_form = $(variations_form),
            size = $(selector).find('.swatches-select').data('size');
         $variation_form.on('click', '.swatches-select > .azx-swatch:not(.is-selected):not(.azx_unavailable)', function(e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var $this = $(this),
                value = $this.data('value'),
                id = $this.parent().data('id'),
                ck_color = $('#cart-form').find('.is-color .is-selected').data('value');
            $this.parent().find('.is-selected').removeClass('is-selected');
            $this.addClass('is-selected');
            if (AzxId == '.azx_select_pr_') {
            $('.azx_select_pr_'+id).find('.is-selected').removeClass('is-selected');
            $(".azx_select_pr_"+id+" [data-value="+value+"]").addClass('is-selected');
            $('.azx_select_pr_'+id+' .input-dropdown-inner >a').text( $(".azx_select_pr_"+id+" [data-value="+value+"]").attr('aria-label'));
            }

            // if( size == 2 && ($(AzxId+'0 .is-selected').length == 0 || $(AzxId+'1 .is-selected').length == 0) ) {
            //   return;
            // } else if( size == 3 && ($(AzxId+'0 .is-selected').length == 0 || $(AzxId+'1 .is-selected').length == 0 || $(AzxId+'2 .is-selected').length == 0) ) {
            //   return;
            // } 
            switch(size) {
                case 2:
                    var value0 = $(AzxId+'0 .is-selected').data('value'),
                        value1 = $(AzxId+'1 .is-selected').data('value'),
                        val = $(IdSelect+' option.'+value0+'.azx1_'+value1).val();
                       // console.log(val);
                     $(IdSelect).val(val);
                    var index = $(AzxId+'0 .is-selected').data('index');
                    if (typeof index === 'undefined') return;
                     $(AzxId+'1 .azx-swatch').addClass('azx_unavailable azx_soldout');
                     var availableOptions = Azxproduct.Azxavailable[index],
                          soldoutOptions = Azxproduct.Azxsoldout[index];
                     //console.log('availableOptions '+availableOptions);
                     // check Unavailable
                      if ($(IdSelect).val() === null || $(IdSelect).val() === ""){
                        //console.log('Unavailable')
                              $(AzxId+'1 .azx-swatch').removeClass('is-selected');
                              $(AzxId+'1 .azx-swatch[data-value="' + availableOptions[0] + '"]').addClass('is-selected');
                              value0 = $(AzxId+'0 .is-selected').data('value'),
                              value1 = $(AzxId+'1 .is-selected').data('value'),
                              val = $(IdSelect+' option.'+value0+'.azx1_'+value1).val();
                              $(IdSelect).val(val);
                              $(AzxId+'0 .input-dropdown-inner >a').text($(AzxId+'0 .is-selected:first').text());
                              $(AzxId+'1 .input-dropdown-inner >a').text($(AzxId+'1 .is-selected:first').text());
                      }// endcheck Unavailable
                         for (var i=0; i<availableOptions.length; i++) {
                           var option = availableOptions[i];
                            $(AzxId+'1 .azx-swatch[data-value="' + option + '"]').removeClass('azx_unavailable');
                         }
                         for (var i=0; i<soldoutOptions.length; i++) {
                           var option = soldoutOptions[i];
                            $(AzxId+'1 .azx-swatch[data-value="' + option + '"]').removeClass('azx_soldout');
                         }
                    break;
                case 3:
                    var value0 = $(AzxId+'0 .is-selected').data('value'),
                        value1 = $(AzxId+'1 .is-selected').data('value'),
                        value2 = $(AzxId+'2 .is-selected').data('value'),
                        val = $(IdSelect+' option.'+value0+'.azx1_'+value1+'.azx2_'+value2).val();
                        $(IdSelect).val(val);
                     var index = $(AzxId+'0 .is-selected').data('index');
                     if (typeof index === 'undefined') return;
                     //console.log(typeof index)
                        var availableOptions = Azxproduct.Azxavailable[index].AZX,
                             soldoutOptions = Azxproduct.Azxsoldout[index].AZX;
                       // check Unavailable
                       if ($(IdSelect).val() === null || $(IdSelect).val() === ""){
                         // id = 0,1,2
                         //console.log('Unavailable')
                         console.log(availableOptions)
                         if (id == 0){
                            var position = availableOptions.indexOf(value1);
                            if (position >=0) {
                              $(AzxId+'2 .azx-swatch').removeClass('is-selected');
                              $(AzxId+'2 .azx-swatch[data-value="' + availableOptions[position+1] + '"]').addClass('is-selected');
                            } else {
                              $(AzxId+'1 .azx-swatch').removeClass('is-selected');
                              $(AzxId+'1 .azx-swatch[data-value="' + availableOptions[0] + '"]').addClass('is-selected');
                              $(AzxId+'2 .azx-swatch').removeClass('is-selected');
                              $(AzxId+'2 .azx-swatch[data-value="' + availableOptions[1] + '"]').addClass('is-selected');
                            }
                         } else if (id == 1){
                           var position = availableOptions.indexOf(value);
                            $(AzxId+'1 .azx-swatch').removeClass('is-selected');
                            $(AzxId+'1 .azx-swatch[data-value="' + availableOptions[position] + '"]').addClass('is-selected');
                            $(AzxId+'2 .azx-swatch').removeClass('is-selected');
                            $(AzxId+'2 .azx-swatch[data-value="' + availableOptions[position+1] + '"]').addClass('is-selected');

                         } else {
                           //code id == 2
                         }
                            value0 = $(AzxId+'0 .is-selected').data('value'),
                            value1 = $(AzxId+'1 .is-selected').data('value'),
                            value2 = $(AzxId+'2 .is-selected').data('value'),
                            val = $(IdSelect+' option.'+value0+'.azx1_'+value1+'.azx2_'+value2).val();
                            $(IdSelect).val(val);
                            $(AzxId+'0 .input-dropdown-inner >a').text($(AzxId+'0 .is-selected:first').text());
                            $(AzxId+'1 .input-dropdown-inner >a').text($(AzxId+'1 .is-selected:first').text());
                            $(AzxId+'2 .input-dropdown-inner >a').text($(AzxId+'2 .is-selected:first').text());
                    }// endcheck Unavailable
                             $(AzxId+'1 .azx-swatch').addClass('azx_unavailable');
                             $(AzxId+'2 .azx-swatch').addClass('azx_unavailable');
                             $(AzxId+'1 .azx-swatch').addClass('azx_soldout');
                             $(AzxId+'2 .azx-swatch').addClass('azx_soldout');
                           //console.log('Unavailable');
                            
                             //console.log(availableOptions)
                             value1 = $(AzxId+'1 .is-selected').data('value');
                             //console.log('value1 '+value1)
                             for (var i=0; i<availableOptions.length; i++) {
                               var option = availableOptions[i];

                               if (i % 2 == 0) {
                                 // select option 2
                                 $(AzxId+'1 .azx-swatch[data-value="' + option + '"]').removeClass('azx_unavailable');
                                  // select option 3
                                  if (option == value1){
                                      var value2 = availableOptions[i+1];
                                    //console.log('value2 '+value2 )
                                     $(AzxId+'2 .azx-swatch[data-value="' + value2 + '"]').removeClass('azx_unavailable');
                                   }
                               }
                             }
      //                        value1 = $(AzxId+'1 .is-selected').data('value');
      //                        console.log('value1 '+value1)
                             for (var i=0; i<soldoutOptions.length; i++) {
                               var option = soldoutOptions[i];
                               //console.log('soldoutOptions '+soldoutOptions)
                               if (i % 2 == 0) {
                                 // select option 2
                                 $(AzxId+'1 .azx-swatch[data-value="' + option + '"]').removeClass('azx_soldout');
                                  // select option 3
                                 
                                  if (option == value1){
                                      var value2 = soldoutOptions[i+1];
                                    //console.log('value2 '+value2 )
                                     $(AzxId+'2 .azx-swatch[data-value="' + value2 + '"]').removeClass('azx_soldout');
                                   }
                               }
                             }
                    break;
                default:
                    var value0 = $(AzxId+'0 .is-selected').data('value'),
                        val = $(IdSelect+' option.'+value0).val();
                    $(IdSelect).val(val);
                    var soldoutOptions = Azxproduct.Azxsoldout;
                    //console.log(soldoutOptions)
                    $(AzxId+'0 .azx-swatch').addClass('azx_soldout');
                    for (var i=0; i<soldoutOptions.length; i++) {
                      var option = soldoutOptions[i];
                      //console.log('option '+option)
                      $(AzxId+'0 .azx-swatch[data-value="' + option + '"]').removeClass('azx_soldout');
                    }
            }
            //AddToCartForm
            var variant = product.variants[$(IdSelect).prop('selectedIndex')];
            selectCallback(variant,selector,IdSelect,size,callBackVariant,AzxId,prefix,product);
               if (((selector == '.azx_cart_form' && typeof $('#cart-form').find('.is-color .is-selected').data('value') !== 'undefined') || (selector == '#cart-form-sticky' && typeof $('#cart-form-sticky').find('.is-color .is-selected').data('value') !== 'undefined')) && azexo_settings.azx_suffix == "group_images" ) {
                 var val_color = $('#cart-form').find('.is-color .is-selected').data('value');
                 var azx_group_slick = $(".azx-group-carousel"), $productGallery = $('.shopify-product-gallery');
                 if ($('.azx-group-carousel:not(.slick-initialized)').length > 0 ) {
                  azx_group_slick.slick().slick('slickFilter', '.bc_'+val_color);
                  azx_group_slick.slick("refresh").addClass('slick_loaded');
                  //ck_color = val_color;
                 } else if ($('.azx-group-carousel.slick-initialized').length > 0 ) {
                   //console.log('val_color: '+val_color)
                  if (ck_color == val_color) return;
                  azx_group_slick.removeClass('slick_loaded').slick("slickUnfilter").slick("unslick");
                  azx_group_slick.slick().slick('slickFilter', '.bc_'+val_color).slick("refresh").addClass('slick_loaded');
                  //ck_color = val_color;
                 } else if ($('.p-thumb.azx-masonry').length > 0 ) {
                     if ($(window).width() > 740 && $(window).width() !== 812) {
                        $('.azx-masonry').addClass('masonry_loaded').isotope({ filter: '.bc_'+val_color }) 
                     } else if ($('.p-thumb.azx-masonry:not(.slick-initialized)').length > 0 ) {
                         setTimeout(function(){
                        $('.p-thumb.azx-masonry').isotope('destroy');
                        $('.p-thumb.azx-masonry').slick().slick('slickFilter', '.bc_'+val_color).slick("refresh").addClass('slick_loaded');
                        $('.p-thumb.azx-masonry.slick-initialized').slick('refresh');
                        }, 1500);
                    } else if ($('.p-thumb.azx-masonry.slick-initialized').length > 0 ) {
                      //console.log('val_color: '+val_color)
                     if (ck_color == val_color) return;
                      $('.p-thumb.azx-masonry').removeClass('slick_loaded').slick("slickUnfilter").slick("unslick");
                      $('.p-thumb.azx-masonry').slick().slick('slickFilter', '.bc_'+val_color).slick("refresh").addClass('slick_loaded');
                        setTimeout(function(){$('.p-thumb.azx-masonry.slick-initialized').slick('refresh');
                        }, 1500);
                    }
               }
               if( $productGallery.hasClass( 'image-action-zoom') ) {
                 var zoom_target   = $( '.shopify-product-gallery__image img' );
                 var image_to_zoom = zoom_target.find( 'img' );
                 // But only zoom if the img is larger than its container.
                 zoom_target.each(function() {
                  var $this = $(this);
                    if ( $this.attr( 'data-large_image_width' ) > $( '.shopify-product-gallery__image' ).width() ) {
                        $this.trigger( 'zoom.destroy' );
                        var zoom_parent = $this.closest('.shopify-product-gallery__image')
                        zoom_parent.zoom({
                           url: $this.attr( 'data-large_image' ), 
                            touch: false
                        });
                    }
                 });
               }
            }
         });
         if (azexo_settings.use_clicking_variant_image){
         $(document).on('click', '.p-nav img', function(ev) {
            //ev.preventDefault();
            var $this = $(this),
                value = $this.data('variant_id');
                //console.log(typeof value)
            if (typeof value === 'number') {
               $(IdSelect).val(value);
               var variant = product.variants[$(IdSelect).prop('selectedIndex')];
               //console.log(variant)
             // $(AzxId+'0 .azx-swatch').removeClass('is-selected');
             // $(AzxId+'0 .azx-swatch[data-value="' + variant.option1 + '"]').addClass('is-selected');
             // $(AzxId+'1 .azx-swatch').removeClass('is-selected');
             // $(AzxId+'1 .azx-swatch[data-value="' + variant.option2 + '"]').addClass('is-selected');
             // $(AzxId+'2 .azx-swatch').removeClass('is-selected');
             // $(AzxId+'2 .azx-swatch[data-value="' + variant.option3 + '"]').addClass('is-selected');
            // $(AzxId+'0 .input-dropdown-inner >a').text($(AzxId+'0 .is-selected').attr('aria-label'));
            // $(AzxId+'1 .input-dropdown-inner >a').text($(AzxId+'1 .is-selected').attr('aria-label'));
            // $(AzxId+'2 .input-dropdown-inner >a').text($(AzxId+'2 .is-selected').attr('aria-label'));
            $(AzxId+'0 .input-dropdown-inner >a').text($(AzxId+'0 .is-selected:first').text());
            $(AzxId+'1 .input-dropdown-inner >a').text($(AzxId+'1 .is-selected:first').text());
            $(AzxId+'2 .input-dropdown-inner >a').text($(AzxId+'2 .is-selected:first').text());
            switch(size) {
              case 2:
                  $(AzxId + '0 .azx-swatch').removeClass('is-selected');
                  $(AzxId + '0 .azx-swatch[data-value="' + variant.option1 + '"]').addClass('is-selected');
                  $(AzxId + '1 .azx-swatch').removeClass('is-selected');
                  $(AzxId + '1 .azx-swatch[data-value="' + variant.option2 + '"]').addClass('is-selected');
                  $(AzxId + '0 .input-dropdown-inner >a').text($(AzxId + '0 .is-selected:first').text());
                  $(AzxId + '1 .input-dropdown-inner >a').text($(AzxId + '1 .is-selected:first').text());
                  var index = $(AzxId + '0 .bg_css_'+variant.option1).data('index');
                  //console.log('value0 index '+index)
                  var availableOptions = Azxproduct.Azxavailable[index],
                      soldoutOptions = Azxproduct.Azxsoldout[index];
                  $(AzxId + '1 .azx-swatch').addClass('azx_unavailable azx_soldout');
                  for (var i = 0; i < availableOptions.length; i++) {
                     var option = availableOptions[i];
                     $(AzxId + '1 .azx-swatch[data-value="' + option + '"]').removeClass('azx_unavailable');
                  }
                  for (var i = 0; i < soldoutOptions.length; i++) {
                     var option = soldoutOptions[i];
                     $(AzxId + '1 .azx-swatch[data-value="' + option + '"]').removeClass('azx_soldout');
                  }
                break;
              case 3:
                  $(AzxId + '0 .azx-swatch').removeClass('is-selected');
                  $(AzxId + '0 .azx-swatch[data-value="' + variant.option1 + '"]').addClass('is-selected');
                  $(AzxId + '1 .azx-swatch').removeClass('is-selected');
                  $(AzxId + '1 .azx-swatch[data-value="' + variant.option2 + '"]').addClass('is-selected');
                  $(AzxId + '2 .azx-swatch').removeClass('is-selected');
                  $(AzxId + '2 .azx-swatch[data-value="' + variant.option3 + '"]').addClass('is-selected');
                  $(AzxId + '0 .input-dropdown-inner >a').text($(AzxId + '0 .is-selected:first').text());
                  $(AzxId + '1 .input-dropdown-inner >a').text($(AzxId + '1 .is-selected:first').text());
                  $(AzxId + '2 .input-dropdown-inner >a').text($(AzxId + '2 .is-selected:first').text());
                  var index = $(AzxId + '0 .bg_css_'+variant.option1).data('index');
                  //console.log('value0 index '+index)
                  var availableOptions = Azxproduct.Azxavailable[index].AZX,
                  soldoutOptions = Azxproduct.Azxsoldout[index].AZX;
                  $(AzxId + '1 .azx-swatch').addClass('azx_unavailable azx_soldout');
                  $(AzxId + '2 .azx-swatch').addClass('azx_unavailable azx_soldout');
                  var value1 = variant.option2;
                  //console.log('value1 '+value1)
                  for (var i = 0; i < availableOptions.length; i++) {
                     var option = availableOptions[i];
                     if (i % 2 == 0) {
                        // select option 2
                        $(AzxId + '1 .azx-swatch[data-value="' + option + '"]').removeClass('azx_unavailable');
                        // select option 3
                        if (option == value1) {
                           $(AzxId + '2 .azx-swatch[data-value="' + availableOptions[i + 1] + '"]').removeClass('azx_unavailable');
                        }
                     }
                  }
                  for (var i = 0; i < soldoutOptions.length; i++) {
                     var option = soldoutOptions[i];
                     if (i % 2 == 0) {
                        // select option 2
                        $(AzxId + '1 .azx-swatch[data-value="' + option + '"]').removeClass('azx_soldout');
                        // select option 3
                        if (option == value1) {
                           $(AzxId + '2 .azx-swatch[data-value="' + soldoutOptions[i + 1] + '"]').removeClass('azx_soldout');
                        }
                     }
                  }
                break;
              default:
                  $(AzxId + '0 .evelix-swatch').removeClass('is-selected');
                  $(AzxId + '0 .evelix-swatch[data-value="' + variant.option1 + '"]').addClass('is-selected');
                  $(AzxId + '0 .input-dropdown-inner >a').text($(AzxId + '0 .is-selected:first').text());
                  var soldoutOptions = Azxproduct.Azxsoldout;
                  $(AzxId + '0 .evelix-swatch').addClass('azx_soldout');
                  for (var i = 0; i < soldoutOptions.length; i++) {
                     var option = soldoutOptions[i];
                     $(AzxId + '0 .evelix-swatch[data-value="' + option + '"]').removeClass('azx_soldout');
                  }
            }
            selectCallback(variant,selector,IdSelect,size,callBackVariant,AzxId,prefix,product);
            }
         });
         }
         var isIOS12 = function() {
            if (/iP(hone|od|ad)/.test(navigator.platform)) {
              var v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);
              return parseInt(v[1], 10) >= 12;
            } else {
              return false;
            }
          };
         var selectCallback = function(variant,selector,IdSelect,size,callBackVariant,AzxId,prefix,product) {
            //console.log('selector: '+selector)
           var selectorCurent = $(selector),
               IdSelectCurent = $(IdSelect);
             var $variantQuantity = selectorCurent.find('.variantQuantity'),
             $productPrice = selectorCurent.find('.productPrice'),
             $quantityElements = selectorCurent.find('.shopify_quantity'),
             $outofstock = $('#azx_outstock'+prefix),
             $outofsticky = $('#azx_outstock_sticky'+prefix),
             $frm_notify_pr = $('#frm_notify_pr'+prefix),
             $productsku = $('#productSku'+prefix),
             $input = selectorCurent.find('.shopify_quantity input.qty'),
             $addToCart = selectorCurent.find('.shopify_add_to_cart'),
             $payment_btn = selectorCurent.find('.shopify-payment-button'),
             $addToCart_text = selectorCurent.find('.single_add_to_cart_button .bt__text');
            //console.log('cookieCurrency :'+$cookieCurrency)
             var val_0 = $(AzxId+'0 .is-selected').data('value'),
                 val_1 = $(AzxId+'1 .is-selected').data('value'),
                 val_2 = $(AzxId+'2 .is-selected').data('value');
             if (size == 2) {
                $(callBackVariant).attr('class','azx_'+val_0);
                $(callBackVariant).addClass('azx1_' + val_1);
                $('#callBackVariantsticky'+prefix).attr('class','azx_'+val_0);
                $('#callBackVariantsticky'+prefix).addClass('azx1_' + val_1);
             } else if (size == 3) {
                $(callBackVariant).attr('class','azx_'+ val_0);
                $(callBackVariant).addClass('azx1_' + val_1);
                $(callBackVariant).addClass('azx2_' + val_2);
                $('#callBackVariantsticky'+prefix).attr('class','azx_'+val_0);
                $('#callBackVariantsticky'+prefix).addClass('azx1_' + val_1);
                $('#callBackVariantsticky'+prefix).addClass('azx2_' + val_2);
             }
            var name_0 = $(AzxId+'0 .bg_css_'+val_0+':first').text();
               $(AzxId+'0 .azx_name_current').html(name_0);
               // if (selector == '#cart-form') {
               //  //$('#azx_select_0 .azx_name_current').html(name_0);
               //   console.log('name_0: '+name_0)
               // // $('#azx_select_sticky_0 .azx_name_current').html(name_0);
               // } else if (selector == '#cart-form-sticky') {
               //  //$('#azx_select_0 .azx_name_current').html(name_0);
               //   console.log('name_sticky: '+name_0)
               //  //$('#azx_select_0 .azx_name_current').html(name_0);
               // }
              
            if (size > 1) {
            var name_1 =  $(AzxId+'1 .bg_css_'+val_1+':first').text();
               $(AzxId+'1 .azx_name_current').html(name_1);
               
            }
            if (size > 2) {
            var name_2 =  $(AzxId+'2 .bg_css_'+val_2+':first').text();
               $(AzxId+'2 .azx_name_current').html(name_2);
                  
            }
            if(variant){
               if (!!(window.history && history.pushState) && azexo_settings.enableHistoryState && selector == '.azx_cart_form'){
                  window.history.replaceState({}, document.title, "?variant=" + variant.id);
               }
                var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
                if(navigator && navigator.appVersion.match(/(iPhone\sOS\s)([\d]+)/gm)){ var os = navigator.appVersion.match(/(iPhone\sOS\s)([\d]+)/gm)[0].split(" ").pop() }
                if( isSafari && isIOS12 && variant.shopify3d !== 'none') {
                  $(".spar-quicklook-overlay a").attr("href", variant.shopify3d[0].url);
                  $('.spar-quicklook-overlay').show();
                }else{$('.spar-quicklook-overlay').hide();}
              if (variant.available) {
                     $addToCart.show();
                     $payment_btn.show();
                     $quantityElements.show();
                     //add.show();
                     //out.css("display", "none");
                     $outofstock.css("display", "none");
                     $outofsticky.css("display", "none");
                     $frm_notify_pr.css("display", "none");
                     $('#product-available'+prefix).removeClass('value_out').addClass('value_in').html(azexo_settings.in_stock);
                     if (azexo_settings.product_quantity_message) {
                        if (variant.inventory_management) {
                          if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
                            $variantQuantity.html(azexo_settings.only_left.replace('1', variant.inventory_quantity)).addClass('is-visible');
                          } else if (variant.inventory_quantity <= 0 && variant.incoming) {
                            $variantQuantity.html(azexo_settings.will_not_ship_until.replace('[date]', variant.next_incoming_date)).addClass('is-visible');
                          } else {
                            $variantQuantity.removeClass('is-visible');
                          }
                        }
                        else {
                          $variantQuantity.removeClass('is-visible');
                        }
                     }
                     // Update quantity.
                     if (variant.inventory_quantity <= 0 && variant.available && variant.inventory_management != null){
                        $addToCart_text.html(azexo_settings.pre_orders);
                        //add.html(azexo_settings.pre_orders);
                     }else{
                       $addToCart_text.html(azexo_settings.add_to_cart);
                       //add.html(azexo_settings.add_to_cart);
                     }
                     if (variant.inventory_quantity <= 0 && variant.available && variant.inventory_management != null){
                       $input.attr('max',999);
                     } else if(variant.inventory_management != null ){
                       //Check if inventory management by shopify
                       $input.attr('max',variant.inventory_quantity).val(1).attr('value',1);
                     }else{
                       $input.attr('max',999);
                     }
              } else {
                     $addToCart.hide();
                     $payment_btn.hide();
                     //add.hide();
                     $('#product-available').removeClass('value_in').addClass('value_out').html(azexo_settings.outofstock);
                     $variantQuantity.removeClass('is-visible');
                     if (azexo_settings.product_quantity_message) {
                        if (variant.incoming) {
                          $variantQuantity.html(azexo_settings.will_be_in_stock_after.replace('[date]', variant.next_incoming_date)).addClass('is-visible');
                        }
                        else {
                          $variantQuantity.removeClass('is-visible');
                        }
                     }
                     $quantityElements.hide();
                     $frm_notify_pr.css("display", "inline-block");
                     $outofstock.css("display", "inline-block");
                     $outofsticky.css("display", "inline-block");
                     //out.css("display", "inline-block");
                     if (azexo_settings.use_notify_me) {
                        var url_js = 'https://'+window.location.hostname+product.url+'?variant='+variant.id;
                        $frm_notify_pr.find('textarea').html(azexo_settings.please_notify_me.replace('{{title}}', product.title).replace('{{variant}}',variant.title).replace('{{url}}', url_js));
                     }
              }
            // Update price display.
            var customPrice = evelixShopifyPre.formatMoney(variant.price, azexo_settings.moneyFormat);
            //console.log($productPrice)
            if (variant.compare_at_price > variant.price) {
               var comparePrice = evelixShopifyPre.formatMoney(variant.compare_at_price, azexo_settings.moneyFormat);
               var customPriceFormat = '<del class="old-product-price">' + comparePrice + '</del> ';
                   customPriceFormat += '<ins class="product-price">' + customPrice + '</ins> ',
                   customPriceFormat += '<span class="onsale fs__14 tu dib cw pr_onsale"><span></span></span>';
               $productPrice.html(customPriceFormat);
               var save = ((variant.compare_at_price - variant.price)*100)/variant.compare_at_price;
               $('#product-'+product.id+' .pr_onsale>span').html(azexo_settings.save_js.replace('[sale]', Math.ceil(save)));
               $('#product-'+product.id+' .pr_onsale').show();
                $('#callBackVariantsticky'+prefix+' .pr_onsale>span').html(azexo_settings.save_js.replace('[sale]', Math.ceil(save)));
               $('#callBackVariantsticky'+prefix+' .pr_onsale').show();
             }else{
                $productPrice.html(customPrice);
                $('#product-'+product.id+' .pr_onsale').hide();
                $('#callBackVariantsticky'+prefix+' .pr_onsale').hide();
             }
             if (azexo_settings.show_multiple_currencies && evelixShopifyPre.StorageCurrency() !== null && typeof(Currency) !== "undefined") {
                if (typeof(Currency.convertAll) !== "undefined") {Currency.convertAll(azexo_settings.shop_currency, evelixShopifyPre.StorageCurrency(), '.entry-summary span.money');}
            }
             //Update sku
             if(variant.sku){
                $productsku.text(variant.sku);
             }else{
                 $productsku.text(azexo_settings.na);
              }
             if(variant.featured_image) {
               var featured_image_id = variant.featured_image.id;
                //console.log(featured_image_id);
               if (selector == '.azx_cart_form' && $('.p-thumb.slick-initialized').length > 0) {
                  var index = $('.p-thumb.slick-initialized .slick-slide:not(.slick-cloned) img[data-image-id='+featured_image_id+']').closest('div.slick-slide').attr( "data-slick-index" );
                  //console.log('index '+ index);
                  $('.p-thumb.slick-initialized').slick('slickGoTo', index);
               }
               if (selector == '#cart-form-quick') {
               var xx = $(".product-images-slider_on").find('img[data-image-id="'+featured_image_id+'"]').closest('div.slick-slide');
                  if(xx.index() >=0){
                    //console.log(xx.index());
                    $('.product-images-slider_on').slick('slickGoTo', [xx.index(), 2, false]);
                  }
               }
             }
            }
         };
      },
      formatMoney: function(cents, format) {
           if (typeof cents == 'string') { cents = cents.replace('.',''); }
           var value = '';
           var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
           var formatString = (format || Azx_money_format);

           var defaultOption = function(opt, def) {
              return (typeof opt == 'undefined' ? def : opt);
           }

           var formatWithDelimiters = function(number, precision, thousands, decimal) {
             precision = defaultOption(precision, 2);
             thousands = defaultOption(thousands, ',');
             decimal   = defaultOption(decimal, '.');

             if (isNaN(number) || number == null) { return 0; };

             number = (number/100.0).toFixed(precision);

             var parts   = number.split('.');
             var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
             var cents   = parts[1] ? (decimal + parts[1]) : '';

             return dollars + cents;
           }

           switch(formatString.match(placeholderRegex)[1]) {
             case 'amount':
               value = formatWithDelimiters(cents, 2);
               break;
             case 'amount_no_decimals':
               value = formatWithDelimiters(cents, 0);
               break;
             case 'amount_with_comma_separator':
               value = formatWithDelimiters(cents, 2, '.', ',');
               break;
             case 'amount_no_decimals_with_comma_separator':
               value = formatWithDelimiters(cents, 0, '.', ',');
               break;
           }

           return formatString.replace(placeholderRegex, value);
      }
   }
   }());
})( jQuery );

jQuery(document).ready(function($) {
   //if ($(window).width() < 991 && !AZX4.designMode) {$('#shopify-section-mega_menu').html('')}
   evelixShopifyPre.init();
   if ($('.p-thumb.azx-masonry:not(.slick-initialized)').length > 0 && azexo_settings.azx_suffix !== "group_images" ) {
      //console.log('resize')
      if ($(window).width() > 740 && $(window).width() !== 812) {
      }else {
          setTimeout(function(){
         $('.p-thumb.azx-masonry').isotope('destroy');
         $('.p-thumb.azx-masonry').slick().slick("refresh").addClass('slick_loaded');
         $('.p-thumb.azx-masonry.slick-initialized').slick('refresh');
         }, 1500);
      }
   }
   if ($('body').hasClass('template-product') && azexo_settings.has_variant) {
         var Azxproduct = JSON.parse(document.getElementById('ProductJson-AZX').innerHTML),
             product = JSON.parse(document.getElementById('ProductJson-template').innerHTML),
             IdSelect = '.product-select_pr',
             AzxId = '.azx_select_pr_',
             selector = '.azx_cart_form',
             callBackVariant = '#callBackVariant',
             prefix='';
             $('.azx_select_pr_1 .is-selected-none').addClass('is-selected').removeClass('is-selected-none');
             $('.azx_select_pr_2 .is-selected-none').addClass('is-selected').removeClass('is-selected-none');
         evelixShopifyPre.Azxproduct_switch('.variations_form',Azxproduct,product,selector,IdSelect,AzxId,callBackVariant,prefix);
         $('.azx_select_pr_0 .is-selected-none').click();
         //$('.azx_select_pr_1 .is-selected-none').click();
         //$('.azx_select_pr_2 .is-selected-none').click();
   }
   if ($('body').hasClass('template-product') && azexo_settings.shopify3d_default) {
    var isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    if(navigator && navigator.appVersion.match(/(iPhone\sOS\s)([\d]+)/gm)){ var os = navigator.appVersion.match(/(iPhone\sOS\s)([\d]+)/gm)[0].split(" ").pop() }
    if( isSafari && os >= 12 ) {$(".spar-quicklook-overlay a").attr("href", azexo_settings.shopify3d[0].url);$('.spar-quicklook-overlay').show();}
  }
});
if (AZX4.designMode) {
   //console.log('section load');
   jQuery(document)
     .on('shopify:section:load', evelixShopifyPre.shopMasonry)
     .on('shopify:section:unload', evelixShopifyPre.shopMasonry)
     .on('shopify:section:select', evelixShopifyPre.shopMasonry)
     .on('shopify:section:deselect', evelixShopifyPre.shopMasonry)
     .on('shopify:block:select',evelixShopifyPre.shopMasonry)
     .on('shopify:block:deselect', evelixShopifyPre.shopMasonry);
   jQuery(document)
     .on('shopify:section:load', evelixShopifyPre.initMasonry)
     .on('shopify:section:unload', evelixShopifyPre.initMasonry)
     .on('shopify:section:select', evelixShopifyPre.initMasonry)
     .on('shopify:section:deselect', evelixShopifyPre.initMasonry)
     .on('shopify:block:select',evelixShopifyPre.initMasonry)
     .on('shopify:block:deselect', evelixShopifyPre.initMasonry);
   jQuery(document)
     .on('shopify:section:load', evelixShopifyPre.initCarousel)
     .on('shopify:section:unload', evelixShopifyPre.initCarousel)
     .on('shopify:block:select',evelixShopifyPre.initCarousel)
     .on('shopify:block:deselect', evelixShopifyPre.initCarousel);
}
